<div class="tutto">
    <app-tws-toolbar></app-tws-toolbar>
    <router-outlet></router-outlet>
    <app-tws-footer></app-tws-footer>
</div>


// WEBPACK FOOTER //
// ./src/app/app.component.html